import type { ProjectData } from "./types";

export const OFFICE_PROJECTS: ProjectData[] = [
  {
    id: "al-salam-bank",
    slug: "al-salam-bank-al-raya-mall-branch",
    title: "Al Salam Bank Al Raya Mall Branch",
    seoTitle: "Al Salam Bank Branch Fit-Out | Al Raya Mall Riffa Bahrain",
    seoDescription:
      "Executive bank branch fit-out for Al Salam Bank at Al Raya Mall Riffa: private wealth lounges, acoustic partitions and custom marble reception by Abacus.",
    category: "Business & Corporate Offices",
    location: "Al Raya Mall at Riffa, Bahrain",
    client: "Al Salam Bank Bahrain",
    year: "2024",
    area: "850 sq. m.",
    description:
      "Executive banking head office with private wealth lounges, acoustic glass partitions, and custom marble reception desks.",
    details:
      "Turnkey fit-out combining high security requirements with warm luxury hospitality aesthetics for VIP bank clients.",
    challengeNarrative:
      "Balancing high-security banking infrastructure (vault access, biometric doors) with warm luxury private wealth lounges.",
    solutionNarrative:
      "Discreetly integrated biometric security devices inside book-matched marble features and timber panelling.",
    scopeOfWork: [
      "Executive Headquarters Fit-Out",
      "Acoustic Double-Glazed Partitions",
      "Custom Marble & Brass Reception Counter",
      "Private VIP Wealth Lounges",
      "MEP & Access Control Infrastructure",
    ],
    tags: [
      "Executive Office Design",
      "Acoustic Partitioning",
      "MEP Infrastructure",
      "Custom Reception Joinery",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/e49f393e-5323-4f8a-b548-d78b8aa7058e.png",
    imageAlt:
      "Al Salam Bank Al Raya Mall branch fit-out Riffa Bahrain - corporate conference boardroom by Abacus",
    additionalImages: [
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a916412722007d7ff06b471.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a9164124fe7419354296617.webp",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a9164124fe741935429661f.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a916412747464c6b3af07de.jpg",
    ],
    keyHighlights: [
      "Acoustic isolation ratings of STC 48+ for confidential VIP rooms",
      "Book-matched Italian Calacatta marble wall cladding",
      "Delivered on schedule with full CBB & Municipality compliance",
    ],
  },
  {
    id: "asry-executive",
    slug: "asry-maritime-executive-headquarters",
    title: "ASRY Maritime Executive Headquarters",
    seoTitle: "ASRY Executive Headquarters Fit-Out | Hidd Bahrain",
    seoDescription:
      "Maritime executive headquarters fit-out for ASRY in Hidd Bahrain: teak joinery, acoustic baffles and panoramic glass boardrooms by Abacus.",
    category: "Business & Corporate Offices",
    location: "Hidd Industrial Area, Bahrain",
    client: "Arab Shipbuilding & Repair Yard (ASRY)",
    year: "2023",
    area: "980 sq. m.",
    description:
      "Maritime shipyard executive headquarters featuring teak wood accents, acoustic ceiling baffles, and panoramic glass boardrooms.",
    details:
      "Complete interior overhaul engineered for durability, marine heritage aesthetics, and acoustic privacy.",
    challengeNarrative:
      "Protecting high-end interior finishes against harsh marine industrial environments nearby.",
    solutionNarrative:
      "Used coastal-rated protective coatings, marine-grade stainless steel hardware, and sealed teak joinery.",
    scopeOfWork: [
      "Executive Headquarters Fit-Out",
      "Marine-Grade Teak Joinery Fabrication",
      "Panoramic Glass Boardroom Enclosures",
      "Industrial-Grade HVAC & Filtration",
      "Acoustic Ceiling & Wall Treatment",
    ],
    tags: [
      "Civil Contracting",
      "Boardroom Joinery",
      "HVAC Upgrade",
      "Acoustic Treatment",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/c7f27c88-1880-47b7-b128-ed97a3112964.jpg",
    imageAlt:
      "ASRY maritime corporate executive office interior - fit-out by Abacus",
    keyHighlights: [
      "Custom teak boardroom table seating 24 executives with built-in AV popup units",
      "Acoustic insulation preventing exterior shipyard noise infiltration",
      "ISO 45001 safety compliant site execution",
    ],
  },
];
